// src/api/emailApi.js
// All email-related API calls to the backend.
// The backend proxies these to Microsoft Graph — your M365
// credentials never touch the frontend.

import apiClient from "./apiClient";

// Fetch inbox messages
export async function getEmails() {
  const response = await apiClient.get("/api/emails");
  return response.data.messages;
}

// Archive email after ticket creation
export async function archiveEmail(messageId) {
  const response = await apiClient.delete(`/api/emails/${messageId}`);
  return response.data;
}

// Move email to Deleted Items (explicit delete action)
export async function deleteEmail(graphId) {
  const response = await apiClient.delete(`/api/emails/${encodeURIComponent(graphId)}`);
  return response.data;
}

// Send a threaded reply to an email
export async function replyToEmail(graphId, htmlBody) {
  const response = await apiClient.post(`/api/emails/${encodeURIComponent(graphId)}/reply`, { body: htmlBody });
  return response.data;
}

// Fetch full email body on demand (called when detail modal opens)
export async function fetchEmailBody(graphId) {
  const response = await apiClient.get(`/api/emails/${encodeURIComponent(graphId)}/body`);
  return response.data; // { body: { content, contentType } }
}